import React from 'react';
import { Link } from 'react-router-dom';
import { trackLinkClick } from '../utils/analytics';

const SiteFooter: React.FC = () => {
  return (
    <footer className="mt-16 border-t border-neutral-200/60 dark:border-neutral-800/60">
      <div className="max-w-5xl mx-auto px-5 py-10">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
          <div className="flex items-center gap-3">
            <img
              src="/icons/flightcents_small.png"
              alt="FlightCents logo"
              className="h-6 w-6 rounded-md shadow-sm"
              loading="lazy"
            />
            <div>
              <p className="text-sm font-semibold text-neutral-900 dark:text-white">FlightCents</p>
              <p className="text-sm text-neutral-600 dark:text-neutral-400">Flight training cost tracker & budgeting tools for student pilots.</p>
            </div>
          </div>

          <nav className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-neutral-600 dark:text-neutral-400">
            <Link to="/faq" className="hover:text-neutral-900 dark:hover:text-neutral-200" onClick={() => trackLinkClick('footer-faq', '/faq', 'site-footer', 'FAQ')}>FAQ</Link>
            <Link to="/blog" className="hover:text-neutral-900 dark:hover:text-neutral-200" onClick={() => trackLinkClick('footer-blog', '/blog', 'site-footer', 'Blog')}>Blog</Link>
            <Link to="/pricing" className="hover:text-neutral-900 dark:hover:text-neutral-200" onClick={() => trackLinkClick('footer-pricing', '/pricing', 'site-footer', 'Pricing')}>Pricing</Link>
            <Link to="/affiliate" className="hover:text-neutral-900 dark:hover:text-neutral-200" onClick={() => trackLinkClick('footer-affiliate', '/affiliate', 'site-footer', 'Student Discounts')}>Student Discounts</Link>
            <Link to="/store" className="hover:text-neutral-900 dark:hover:text-neutral-200" onClick={() => trackLinkClick('footer-store', '/store', 'site-footer', 'Pilot Store')}>Pilot Store</Link>
            <Link to="/benchmark" className="hover:text-neutral-900 dark:hover:text-neutral-200" onClick={() => trackLinkClick('footer-benchmark', '/benchmark', 'site-footer', 'Benchmark Tool')}>Benchmark Tool</Link>
            <Link to="/schools" className="hover:text-neutral-900 dark:hover:text-neutral-200" onClick={() => trackLinkClick('footer-schools', '/schools', 'site-footer', 'Flight Schools')}>Flight Schools</Link>
            <Link to="/contact" className="hover:text-neutral-900 dark:hover:text-neutral-200" onClick={() => trackLinkClick('footer-contact', '/contact', 'site-footer', 'Contact')}>Contact</Link>
            <Link to="/privacy" className="hover:text-neutral-900 dark:hover:text-neutral-200" onClick={() => trackLinkClick('footer-privacy', '/privacy', 'site-footer', 'Privacy')}>Privacy</Link>
          </nav>
        </div>

        <div className="mt-6 text-xs text-neutral-500 dark:text-neutral-500">
          © {new Date().getFullYear()} FlightCents. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
